<div class="field-container">
    
    

    <div class="form-group">
        <label for="oldPassword">
            {{ 'profile.skd.psw.chanPsw.oldPassword' | transloco }}
        </label>
        <div class="input-group">
            <input [type]="showPasswords ? 'text' : 'password'" id="oldPassword" [(ngModel)]="oldPassword" kendoTextBox required class="k-textbox flex-grow" />
        </div>
    </div>

    <div class="form-group">
        <label for="newPassword">{{ 'profile.skd.psw.chanPsw.newPassword' | transloco }}</label>
        <div class="input-group">
            <input [type]="showPasswords ? 'text' : 'password'" id="newPassword" [(ngModel)]="newPassword" kendoTextBox required class="k-textbox flex-grow" (ngModelChange)="validateNewPassword()" />
        </div>
        <div *ngIf="newPasswordError" class="hint-notification">{{ newPasswordError }}</div>
    </div>

    <div class="form-group">
        <label for="confirmNewPassword">{{ 'profile.skd.psw.chanPsw.confirmNewPassword' | transloco }}</label>
        <div class="input-group">
            <input [type]="showPasswords ? 'text' : 'password'" id="confirmNewPassword" [(ngModel)]="confirmNewPassword" kendoTextBox required class="k-textbox flex-grow"  (ngModelChange)="validateNewPassword()" />
        </div>
        <div *ngIf="passwordNotMatchError" class="hint-notification">{{ passwordNotMatchError }}</div>
    </div>

    <div class="button-container">
        <div class="show-password-container">
            

            <button type="button" kendoButton class="save-button" (click)="toggleShowPasswords()">
                <mat-icon>{{ showPasswords ? 'visibility_off' : 'visibility' }}</mat-icon>
                 {{ 'profile.skd.psw.chanPsw.showPwd' | transloco }}
            </button>
        </div>
    
        <button type="button" (click)="changePassword()" kendoButton class="save-button">
            <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
            {{ 'profile.skd.psw.chanPsw.savPwd' | transloco }}
        </button>
    </div>
    
    <div *ngIf="notification" [class]="notification.type + '-notification'">
        {{ notification.message }}
    </div>
</div>
